import {ModalActions} from "../constants/modalActions";

const INITIAL_STATE = {

    loginModal: false,
    settings: false

};
export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case ModalActions.HANDLE_LOGIN_MODAL:

            return { ...state, loginModal: action.payload.loginModal  };
        case ModalActions.HANDLE_SETTINGS_MODAL:

            return { ...state, settings: action.payload.settings  };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/modal.ts